import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { useClassnames } from "./classnames";
import { Actions } from "../../../../../components";
import { Close as CloseIcon } from "@material-ui/icons";

type Props = {
  onCancel: () => void;
  onSubmit: () => void;
  open: boolean;
  size?: "sm" | "md";
  title: string;
  readonly?: boolean;
};

export const Wrapper: React.FC<Props> = ({
  children,
  onCancel,
  onSubmit,
  open,
  size,
  title,
  readonly,
}) => {
  const classnames = useClassnames();

  return (
    <Dialog
      classes={{
        paper: classnames.paper,
      }}
      fullWidth
      maxWidth={size || "sm"}
      onClose={onCancel}
      open={open}
      scroll="body"
    >
      <DialogTitle disableTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography variant="h6" color="primary">
                  {title}
                </Typography>
              </Box>
              <Box display="flex" pl={1} marginX="-9px" marginY="-3px">
                <IconButton size="small" onClick={onCancel}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Actions>
              <Actions.Action outlined onClick={onCancel}>
                {readonly ? "Close" : "Cancel"}
              </Actions.Action>
              {!readonly ? (
                <Actions.Action onClick={onSubmit}>Submit</Actions.Action>
              ) : null}
            </Actions>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
